import { Button } from 'antd'
import DashboardImg from '../../../Assets/b2b2c_dashboard_img.png'
import React from 'react'
import styled from 'styled-components'
import IpadImg from '../../../Assets/ipadB2B2C.png'
import { FiUserCheck } from "react-icons/fi";
import { LuTvMinimalPlay } from "react-icons/lu";
import { LuShieldCheck } from "react-icons/lu";
import { BsActivity } from "react-icons/bs";
import { LuBookOpenText } from "react-icons/lu";
import { FiAlertTriangle } from "react-icons/fi";
import B2B2CBanner from "../../../Assets/b2b2c-banner.png";
import B2B2CBannerText from "../../../Assets/b2b2c-banner-text.png";
import AppStoreDownload from "../../../Assets/B2B2C-App-Store-Download.svg";
import PlayStoreDownload from "../../../Assets/B2B2C-PlayStore-Download.svg";
import ImageHorizontalView from './ImageHorizontalView'
import GroupImageDashboard from '../../../Assets/B2B2C-dashboard-group-image.png'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
// import VerticalLineWithCircles from './VerticalLine'

const ContentB2B2C = (props) => {
    const {referralCode, userEmail} = props;

    const history = useHistory();
    const featureMapping = [
        {
            icon: <FiUserCheck size={40} />,
            heading: 'Certified therapists & coaches',
            info: 'Access a hand-picked team of licensed professionals and certified coaches who guide you every step of the way.'
        },
        {
            icon: <LuTvMinimalPlay size={40} />,
            heading: 'Video & chat sessions',
            info: 'Choose how you connect — via live video or secure chat — so help fits your schedule and comfort level.'
        },
        {
            icon: <LuShieldCheck size={40} />,
            heading: 'Private & confidential',
            info: 'Your conversations and data stay completely private, ensuring a safe and discreet space to explore wellbeing.'
        },
        {
            icon: <BsActivity size={40} />,
            heading: 'Wellbeing Meter & Therapy TrackerWellbeing Meter & Therapy Tracker',
            info: 'Monitor your overall wellness and track progress over time with intuitive tools built into the app.'
        },
        {
            icon: <LuBookOpenText size={40} />,
            heading: 'Personal Journal & Resource Center',
            info: 'Keep a private journal, and tap into an extensive library of articles, videos and exercises that support your journey.',
        },
        {
            icon: <FiAlertTriangle size={40} />,
            heading: 'Emergency Help Button',
            info: 'In moments of crisis or urgent need, one tap gives you immediate access to the right help when it matters most.'
        }
    ]
    return (
        <div style={{
            padding: '0px 80px',
            paddingTop:'80px',
        }}>


            {/* Page-1 */}

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',

                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '32px',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        width: '630px',
                    }}
                >
                    <div>
                        <div
                            style={{
                                fontFamily: 'Montserrat',
                                fontWeight: 600, // "SemiBold" equivalent
                                fontStyle: 'normal',
                                fontSize: '64px',
                                lineHeight: '100%',
                                letterSpacing: '0',
                                verticalAlign: 'middle',
                                textTransform: 'capitalize',
                            }}
                        >
                            Your wellbeing,
                        </div>

                        <div
                            style={{
                                fontFamily: 'Montserrat',
                                fontWeight: 600,
                                fontStyle: 'normal',
                                fontSize: '64px',
                                lineHeight: '100%',
                                letterSpacing: '0',
                                verticalAlign: 'middle',
                                textTransform: 'capitalize',
                                color: '#28BF8D',
                            }}
                        >
                            Simplified
                        </div>
                    </div>

                    <div
                        style={{
                            fontFamily: 'Montserrat',
                            fontWeight: 500, // "Medium" corresponds to weight 500
                            fontStyle: 'normal', // "Medium" is not a valid CSS font-style
                            fontSize: '18px',
                            // lineHeight: '100%', // you had 120%, but per your request: 100%
                            letterSpacing: '0',
                            verticalAlign: 'middle',
                            color: '#472567',
                            textAlign: 'start',
                        }}
                    >
                        SupportRoom Plus gives you instant access to certified professionals, private sessions, and digital tools
                        designed to support your mental health: anytime, anywhere.
                    </div>

                    <Button
                        style={{
                            marginTop: '10px',
                            height: '48px',
                            width: '159px',
                            padding: '14px 32px',
                            borderRadius: '10px',
                            borderColor: '#28BF8D',
                            backgroundColor: '#28BF8D',
                            color: '#fff',
                            fontFamily: 'Montserrat',
                            fontWeight: 600, // "Medium" corresponds to weight 500
                            fontStyle: 'normal', // "Medium" is not a valid CSS font-style
                            fontSize: '16px',
                        }}
                        onClick={() => {
                            history.push(`/payment-b2b2c?referral_code=${referralCode}&email=${userEmail}`)
                        }}
                    >
                        Get Started
                    </Button>
                </div>

                <img src={DashboardImg} height={560} width={630} />
            </div>

            {/* Page-2 */}

            <div style={{
                marginTop: '200px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: '80px',
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '20px'
                }}>
                    <div style={{
                        backgroundColor: '#FFF2FF',
                        height: '500px',
                        width: '630px',
                        borderRadius: '32px',
                        padding: '0px 40px',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            fontFamily: 'Montserrat',
                            fontWeight: 600,
                            fontSize: '36px'
                        }}>
                            Support that goes
                        </div>
                        <div style={{
                            fontFamily: 'Montserrat',
                            fontWeight: 600,
                            fontSize: '36px'
                        }}>
                            Beyond the workplace
                        </div>

                        <div
                            style={{
                                marginTop: '40px',
                                fontFamily: 'Montserrat',
                                fontWeight: 500, // "Medium" = weight 500
                                fontStyle: 'normal', // "Medium" is not a valid CSS font-style
                                fontSize: '18px',
                                lineHeight: '100%',
                                letterSpacing: '0',
                                verticalAlign: 'middle',
                            }}
                        >
                            SupportRoom Plus extends the trusted SupportRoom experience to everyone.
                            Whether you’ve received a voucher from a loved one or want professional
                            support for yourself, you can now access our experts directly through the
                            SupportRoom Plus app.
                        </div>


                    </div>

                    <div style={{
                        backgroundColor: '#FFF2FF',
                        height: '500px',
                        width: '630px',
                        borderRadius: '32px',
                        padding: '0px 40px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <img src={IpadImg} />
                    </div>

                </div>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '20px',
                    marginTop: '60px',
                }}>
                    {
                        featureMapping?.map((el) => {
                            return (
                                <div style={{
                                    height: '212px',
                                    padding: '24px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '20px',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    boxShadow: '0px 10px 20px 0px #4725671A',
                                    borderRadius: '16px'
                                }}>
                                    {el?.icon}
                                    <div style={{
                                        fontFamily: 'Montserrat',
                                        fontWeight: 600,
                                        fontSize: '20px',
                                        color: '#472567',
                                    }}>
                                        {el.heading}

                                    </div>

                                    <div style={{
                                        fontFamily: 'Montserrat',
                                        fontWeight: 500,
                                        fontSize: '16px',
                                        color: '#472567',
                                    }}>
                                        {el?.info}

                                    </div>

                                </div>
                            )
                        })
                    }
                </div>

                <Button style={{
                    backgroundColor: '#28BF8D',
                    color: '#fff',
                    borderRadius: '10px',
                    height: '48px',
                    padding: '14px 32px',
                    marginTop: '60px',
                    marginBottom: '120px',
                }}>
                    Learn More
                </Button>

            </div>

            <div
                style={{
                    padding: '120px 80px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '60px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '60px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%'
                }}>
                    <img src={B2B2CBanner} height={520} />
                    <img src={B2B2CBannerText} height={520} />
                </div>

                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '24px'
                }}>
                    <img src={AppStoreDownload} height={63} width={196} style={{
                        cursor: 'pointer'
                    }} />
                    <img src={PlayStoreDownload} height={63} width={196} style={{
                        cursor: 'pointer'
                    }} />

                </div>

            </div>

            <div style={{
                backgroundColor: '#FFF2FF',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                // justifyContent:'center'
                marginLeft: '-80px',
                marginRight: '-80px',
                gap: '80px',
            }}>
                <div style={{
                    marginTop: '120px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '36px',
                        color: '#472567'
                    }}>
                        Trusted, Private,
                    </div>
                    <div style={{
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '36px',
                        color: '#472567'
                    }}>
                        And <span style={{ color: '#28BF8D' }}>Professional Care</span> At Your Fingertips
                    </div>

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '1064px',
                        marginTop: '24px',
                        textAlign: 'center',
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        fontSize: '18px',
                    }}>
                        SupportRoom is trusted by employers and individuals around the world. With SupportRoom Plus, you’re getting the same level of expert care used by thousands of employees now available directly to you.
                    </div>
                </div>


                {/* <ImageHorizontalView/> */}



                <Button style={{
                    marginBottom: '60px',
                    backgroundColor: '#28BF8D',
                    padding: '14px 32px',
                    fontFamily: 'Montserrat',
                    fontSize: '16px',
                    fontWeight: 600,
                    color: '#fff',
                    borderRadius: '10px',
                    gap: '10px',
                    height: '48px',
                    borderColor: '#28BF8D',
                }}>
                    Join Now
                </Button>
            </div>

            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: '#472567',
                margin: '0px -80px'
            }}>

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '24px',
                    marginTop: '118px',
                    marginBottom: '118px',
                    marginLeft: '80px',
                    width: '522px'
                }}>
                    <div style={{
                        fontFamily: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '36px',
                        color: '#fff',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <div>
                            Take the first step
                        </div>
                        <div>
                            toward better wellbeing
                        </div>

                    </div>

                    <div style={{
                        fontFamily: 'Montserrat',
                        fontWeight: 500,
                        fontSize: '18px',
                        color: '#fff'
                    }}>
                        Join SupportRoom Plus today and access professional care in minutes.
                    </div>

                    <Button style={{
                        marginTop: '60px',
                        width: '201px',
                        height: '48px',
                        padding: '14px 32px',
                        backgroundColor: '#28BF8D',
                        color: '#fff',
                        fontWeight: 'Montserrat',
                        fontWeight: 600,
                        fontSize: '16px',
                        borderRadius: '10px',
                        borderColor: '#28BF8D'
                    }}>
                        Get Started Now
                    </Button>

                </div>
                <img src={GroupImageDashboard} style={{ marginTop: '10.5px', marginRight: '8.5px' }} />



            </div>

        </div>
    )
}

const TitleHeading = styled.div`

`

export default ContentB2B2C